import firebase from "@/common/firebase";

let refreshTokenTimer;

export const clearRefreshTokenTimeout = () => clearTimeout(refreshTokenTimer);

export const putTokenToStorage = (token) => {
  localStorage.setItem("token", token);

  clearTimeout(refreshTokenTimer);
  const expirationTime = 1000 * 60 * 55; // 55 minutes
  refreshTokenTimer = setTimeout(
    async () =>
      putTokenToStorage(await firebase.auth().currentUser.getIdToken(true)),
    expirationTime
  );
};
